module.exports = __webpack_public_path__ + "assets/img/ljcy.464f6ac0.png";